export function msUntilExpiry(validatedAtIso: string, ttlMs: number = 3600_000): number {
  // Normalize ISO string to UTC: append 'Z' if missing timezone designator
  const isoString = validatedAtIso.match(/[zZ]$|[+\-]\d{2}(:\d{2})?$/)
    ? validatedAtIso
    : `${validatedAtIso}Z`;
  const validatedAt = new Date(isoString).getTime();
  return ttlMs - (Date.now() - validatedAt);
} 